import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { Home, Login, Menues, Profile, Impressum, Information, Uploads, AnamneseEntry, Einverstaendnis, Rehaziele, Screening } from '../pages';

const Main = (props) => {

  const { user } = useAuthenticator((context) => [context.user]);
  const massnid = user ? user.attributes ? user.attributes['custom:kvsID'] : undefined : undefined;
  // console.log(user)

  return (
        <HashRouter>
          <Routes>
            <Route exact path="/"        element={<Home />}    />
            <Route exact path="/anamnese" element={<AnamneseEntry authenticated={user} massnid={massnid} />} />
            <Route exact path="/menues" element={<Menues />} />
            <Route exact path="/profile" element={<Profile user={user} />} />
            <Route exact path="/login"   element={<Login />}   />
            <Route exact path="/impressum" element={<Impressum />}   />
            <Route exact path="/information" element={<Information />}   />
            <Route exact path="/uploads" element={<Uploads />}   />
            <Route exact path="/einverstaendnis" element={<Einverstaendnis />}   />
            <Route exact path="/screening" element={<Screening />}   />
            <Route exact path="/rehaziele" element={<Rehaziele />}   />
          </Routes>
        </HashRouter>
  )
}

export default Main;